import { useEffect, useState } from "react";
import type { ValidationTemplate } from "../types/validation-templates";
import { validationTemplatesService } from "../services/validation-templates-services";

const defaultLanguage: ValidationTemplate = {
  id: null,
  name: "",
  author: "",
  dateModified: "",
  rules: [],
  isDefault: false,
  additionalRules: {
    isSpecialCharValidationEnabled: false,
    isStartEndValidationEnabled: false,
    isSameNumberAfterMacro: false,
  },
};

export const useFetchValidationTemplate = (
  id: number | undefined,
  isCreate?: boolean,
): [ValidationTemplate | undefined, boolean] => {
  const [validationTemplate, setValidationTemplate] = useState<ValidationTemplate | undefined>(() =>
    isCreate ? defaultLanguage : undefined,
  );
  const [isFetching, setIsFetching] = useState<boolean>(!isCreate);

  useEffect(() => {
    if (!id) {
      setIsFetching(false);
      return;
    }

    const abortController = new AbortController();

    async function fetchData() {
      setIsFetching(true);

      try {
        const response: ValidationTemplate = await validationTemplatesService.getValidationTemplate(
          id!,
          abortController,
        );

        setValidationTemplate(response);
      } catch (error) {
        console.error(error);
      }

      setIsFetching(false);
    }

    if (!isCreate) {
      fetchData();
    }

    return () => {
      abortController.abort();
    };
  }, [id, isCreate]);

  return [validationTemplate, isFetching];
};
